import { createReducer, on } from '@ngrx/store';
import * as MediaActiions from './media.actions';
import { MediaFile } from '../../gallery/media-file.model';

export const featureKey = 'media';

export interface HubMediaState {
  photos: MediaFile[];
  videos: MediaFile[];
  tours: MediaFile[];
  infographics: MediaFile[];
  marketing_graphics: MediaFile[];
}

export const initialState: HubMediaState = {
  photos: [],
  videos: [],
  tours: [],
  infographics: [],
  marketing_graphics: [],
};

export const reducer = createReducer(
  initialState,

  on(MediaActiions.setMediaData, (state, action) => ({
    ...state,
    ...action.data
  })),

  on(MediaActiions.resetMediaData, () => ({
    ...initialState
  })),

  on(MediaActiions.addNewMediaFileInStore, (state, action) => {
    const key = (action.item.media_type + 's') as keyof HubMediaState;
    return {
      ...state,
      [key]: [
        ...state[key],
        action.item,
      ]
    };
  })
);
